import type { MetricDim } from "@csbi/contracts"
import type { MetricDefinition } from "./types.js"

/**
 * ⚠ **`text` and `timestamp` metrics must be split by every dimension they declare — all of them.**
 */
export function defaultSplitFor(metric: MetricDefinition): readonly ("period" | MetricDim)[] {
  if (metric.valueType === "text" || metric.valueType === "timestamp") {
    // Attribute metrics: every dimension. An attribute metric with no dims should not exist
    // (it would have no subject), but if one appears, splitting by period beats throwing —
    // this is not the validation point; the catalog self-check is.
    return metric.dims.length > 0 ? [...metric.dims] : ["period"]
  }

  const [first] = metric.dims

  return first ? [first] : ["period"]
}
